var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{ref:"chart",style:({ width: _vm.width, height: _vm.height }),attrs:{"options":_vm.computedOptions,"auto-resize":""},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }